<ct-expansion-panel [configuration]="this.panelConfiguration" *ngIf="this.panelConfiguration"></ct-expansion-panel>

<ng-template #companyInformationTemplate>

<!-- company-display.component.html -->
<div class="company-display-container" *ngIf="company">
  
  <!-- Griglia delle informazioni -->
  <div *ngIf="hasDataToShow()" class="company-info-grid">
    
    <!-- Iterazione sui campi da mostrare -->
    <div *ngFor="let field of displayFields" class="info-item">
      <span class="info-label">{{ field.label }}:</span>
      <span class="info-value" [class.empty-value]="isEmpty(getFieldValue(field))">
        {{ getFieldValue(field) }}
      </span>
    </div>
    
  </div>
  
  <!-- Messaggio se non ci sono dati -->
  <div *ngIf="!hasDataToShow()" class="no-data-message">
    <p>Nessuna informazione disponibile</p>
  </div>
  
  <!-- Sezione opzionale per tags se presenti nell'array visibleFields -->
  <!-- <div *ngIf="company.Tags && company.Tags.length > 0 && this.companyInformationModel.visibleFields.includes('Tags')" class="tags-section">
    <div class="tags-container">
      <span *ngFor="let tag of company.Tags" class="tag-item">
        {{ tag.Name || tag }}
      </span>
    </div>
  </div> -->
  
  <!-- Sezione opzionale per places se presenti nell'array visibleFields -->
  <div *ngIf="company.Places && company.Places.length > 0 && this.companyInformationConfiguration.visibleFields.includes('Places')" class="places-section">
    <div class="places-list">
      <div *ngFor="let place of company.Places; let i = index" class="place-item">
        <span class="place-index">Sede {{ i + 1 }}:</span>
        <span class="place-info">{{ place.FullAddress || place }}</span>
      </div>
    </div>
  </div>
  
</div>
</ng-template>